module.exports = __webpack_public_path__ + "static/img/jp_zhhb.2ff4ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_zhhb.png
// module id = ryzn
// module chunks = 1